import { render, staticRenderFns } from "./CampaignServices.vue?vue&type=template&id=4f050c4a&scoped=true&"
import script from "./CampaignServices.vue?vue&type=script&lang=js&"
export * from "./CampaignServices.vue?vue&type=script&lang=js&"
import style0 from "./CampaignServices.vue?vue&type=style&index=0&id=4f050c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f050c4a",
  null
  
)

export default component.exports